import React, { useState } from "react";
import { makeStyles } from '@material-ui/styles';
import withShowToast from '../../../../hocs/with_show_toast.js';
import { compose } from 'redux';

import Container from "../../../../base/components/container.js.jsx";
import HtmlContent from "../../../../base/components/html_content.js";
import I18n from "../../../../base/i18n.js.jsx";

import Button from "../../../../base/buttons/button.js.jsx";
import TextField from "../../../../base/inputs/text_field.js.jsx";
import Checkbox from "../../../../base/inputs/checkbox.js";

import NewslettersSubscriptionUseCase from "../../../../use_cases/newsletters/subscription.js.jsx";
import CreateTokenUseCase from "../../../../use_cases/recaptcha/create_token_use_case.js.jsx";

import BlockHeader from "./block_header.js";

import Routes from "../../../routes.js";

import Analytics, { NewsletterSourceMainPage } from "../../../../utils/analytics";

const subscribeAction = "index_subscribe";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grayBg,
  },
  content: {
    padding: "36px 16px 50px",
    ['@media (max-width: 768px)']: {
      padding: "26px 24px 40px",
    },
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0px 40px",
    ['@media (max-width: 768px)']: {
      padding: "0px 0px",
      marginTop: "-5px"
    },
  },
  text: {
    display: "block",
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "18px",
    textAlign: "center",
    maxWidth: "710px",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
      textAlign: "left",
      width: "100%",
      maxWidth: "100%",
    },
  },
  agreementContainer: {
    display: "flex",
    marginTop: "-50px",
    ['@media (max-width: 768px)']: {
      marginTop: "auto",
    },
  },
  agreementCheckbox: {
    marginLeft: "0px",
    marginTop: "5px"
  },
  agreement: {
    textAlign: "left",
    fontSize: "16px",
    marginTop: "36px",
    marginBottom: "20px",
    "& a": {
      color: theme.palette.black
    },
    ['@media (max-width: 768px)']: {
      fontSize: "10px",
      lineHeight: "17px",
      marginTop: "-4px",
      marginBottom: "0px",
      textAlign: "left",
    },
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  textField: {
    maxWidth: "710px",
    minWidth: "312px",
    margin: "32px 0px",
    "& .MuiFilledInput-input": {
      fontSize: "18px",
      padding: "18px 13px 15px",
      ['@media (max-width: 768px)']: {
        fontSize: "14px",
        padding: "17px 13px 10px",
      },
    },
    "& .MuiInputLabel-filled": {
      transform: "translate(15px, 18px) scale(1)",
      fontSize: "14px",
      ['@media (max-width: 768px)']: {
        fontSize: "12px",
        fontWeight: theme.typography.fontWeightLight
      },
    },
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
      transform: "translate(12px, 6px) scale(0.7)",
      ['@media (max-width: 768px)']: {
        transform: "translate(12px, 9px) scale(0.7)",
      },
    },
    ['@media (max-width: 768px)']: {
      minWidth: "0px",
      margin: "20px 0px",
      maxWidth: "100%",
    },
    "& .MuiInputLabel-formControl": {
      ['@media (max-width: 768px)']: {
        top: "-5px"
      },
    },
    "& .MuiInputBase-input": {
      textAlign: "center"
    }
  },
  subscribe: {
    width: "100%",
    maxWidth: "312px"
  },
}));

const SubscribeBlock = (props) => {
  const classes = blockStyles();

  const { showSuccessMessage, showErrorMessage } = props;

  const [subscribeEmail, setSubscribeEmail] = useState("");
  const [submitting, setSubmitting] = useState(false)
  const [agreement, setAgreement] = useState(false)

  const onChangeEmail = (value) => {
    setSubscribeEmail(value);
  }

  const onSubmit = (event) => {
    event.preventDefault();

    setSubmitting(true)

    const params = {
      email: subscribeEmail
    }

    grecaptcha.ready(() => {
      CreateTokenUseCase.execute(subscribeAction)
        .then(token => {
          return NewslettersSubscriptionUseCase.execute(params, token)
        })
        .then(() => {
          Analytics.subscribedToNewsletter(subscribeEmail, NewsletterSourceMainPage);
          setSubmitting(false);
          showSuccessMessage(I18n.t("web.subscription.success"));
        })
        .catch(result => {
          const { message } = result;
          setSubmitting(false);
          showErrorMessage(message);
        })
    })
  }

  const onChangeAgreement = (event) => {
    setAgreement(event)
  }

  const agreementDisplayName = <HtmlContent className = { classes.agreement } >
    { I18n.t("web.subscription.agreement", {data_protection: Routes.dataProtection()}) }
  </HtmlContent>

  return (
    <div className = { classes.root } >
      <Container className = { classes.content }>
        <BlockHeader>
          { I18n.t("web.subscription.title") }
        </BlockHeader>
        <div className = { classes.formContainer } >
          <span className = { classes.text } >
            { I18n.t("web.subscription.text") }
            <form onSubmit = { onSubmit }
                  className = { classes.form } >
              <TextField variant = { "filled" }
                         underline = { false }
                         type = { "email" }
                         value = { subscribeEmail }
                         onChange = { onChangeEmail }
                         className = { classes.textField }
                         name = { "email" }
                         displayNamePosition =  { "above" }
                         placeholder = { I18n.t("web.subscription.email") }/>
              <div className = { classes.agreementContainer } >
                <Checkbox className = { classes.agreementCheckbox }
                          displayName = { agreementDisplayName }
                          onChange = { onChangeAgreement } />
              </div>
              <Button className = { classes.subscribe }
                      type = { "submit" }
                      disabled = { submitting || !agreement } >
                { I18n.t("action.subscribe") }
              </Button>
            </form>
          </span>
        </div>
      </Container>
    </div>
  );
}

export default compose(withShowToast)(SubscribeBlock);
